import { Decimal } from 'decimal.js';

import type { BookingProps } from './booking/booking.schema';

export const pointsToCash = (points: Decimal, tiers: BookingProps['reservation']['offer']['pointsTierInstance']) => {
  const absPoints = points.abs();

  const cashAmount = tiers.levels.reduce(
    (total, tier) => {
      if (absPoints.greaterThan(total.points)) {
        const maxPointsForTier = (tier.max as Decimal).minus(tier.min as Decimal).dividedBy(tier.rate as Decimal);
        const pointsForTier = Decimal.min(maxPointsForTier, absPoints.minus(total.points));
        const cashAmountForTier = pointsForTier.times(tier.rate as Decimal);

        return {
          cash: total.cash.plus(cashAmountForTier),
          points: total.points.plus(pointsForTier),
        };
      }
      return total;
    },
    { cash: new Decimal(0), points: new Decimal(0) },
  ).cash;

  const resultAmount = points.isNegative() ? cashAmount.neg() : cashAmount;
  return resultAmount.toDecimalPlaces(2, Decimal.ROUND_HALF_EVEN);
};
